import React from 'react'
import { createPortal } from 'react-dom'
import { Modal } from '@mobi/component-library/Overlays/Modal/Modal'
import { layering } from '@mobi/component-library/Theme/Common'
import { Button } from '@mobi/component-library/Common/V2/Buttons'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { Constants } from '@mobi/settings/constants'
import betLoopPreviewImage from './assets/bet-loop-preview.png'

const enum LocalConstants {
  Title = 'Bet Loop has arrived!',
  SubTitle = 'Scroll the latest bets from top tipsters and fellow punters. Jump in, copy a bet, or throw your own into the mix.',
}

export const BetLoopTAndCsModal: React.FC<{
  isOpen: boolean
  isCreatingProfile: boolean
  onAccept(): void
}> = ({ isOpen, isCreatingProfile, onAccept }) => {
  const onCancel = () => appHistory.push(AppRoutes.Home)

  return createPortal(
    <Modal
      isOpen={isOpen}
      headerTitle={LocalConstants.Title}
      headerSubtitle={
        <>
          <p>{LocalConstants.SubTitle}</p>
          <p>
            By continuing, you agree to our{' '}
            <a href={Constants.TermsAndConditions} target='_blank'>
              T&Cs
            </a>
          </p>
        </>
      }
      headerTextAlignment='left'
      headerImage={
        <img src={betLoopPreviewImage} width='363' height='299' alt='Bet Loop preview' />
      }
      dismissStatus='disallowed'
      onDismiss={onCancel}
      zIndex={layering.overlayHigh}
      footerComponent={
        <>
          <Button
            size='md'
            isFullWidth
            color='secondary_grey'
            onClick={onCancel}
            disabled={isCreatingProfile}
            data-testid='BetLoopTCs.Cancel'
          >
            Later
          </Button>

          <Button
            size='md'
            isFullWidth
            color='primary'
            onClick={onAccept}
            isLoading={isCreatingProfile}
            data-testid='BetLoopTCs.Accept'
          >
            Accept & Continue
          </Button>
        </>
      }
    />,
    document.body
  )
}
